import { useState } from 'react';
import { Button, Icon } from 'semantic-ui-react';
import './InventFinishContentButton.scss';
import api from '../../../../../../utils/api';

interface InventFinishContentButtonProps {
    projectId: string;
    partId: string;
    fragmentId: string;
    onInvent: (content: string) => void;
}

function InventFinishContentButton({projectId, partId, fragmentId, onInvent}:InventFinishContentButtonProps) {
    const [isLoading, setIsLoading] = useState(false);
    const invent = async () => {
        setIsLoading(true);
        let content = await api.inventFinishContentForFragment(projectId, partId, fragmentId)
        onInvent(content);
        setIsLoading(false);
    };
    return <div className='invent-finish-content-button-container'>
        <Button loading={isLoading} size='tiny' icon basic onClick={invent}><Icon name='magic' /> Придумать</Button>
    </div>
};

export default InventFinishContentButton;